import {createSelector} from '@ngrx/store';
import {AppState} from '../states/app.state';
import {identity} from 'rxjs';


export class UserViewConfigSelectors {

  private static select = {
    userViewConfigState: (state: AppState) => state.userViewConfig,
    isInitCheckDone: (state: AppState) => state.userViewConfig.meta.isInitCheckDone,
    isValidConfigAvailable: (state: AppState) => state.userViewConfig.meta.isValidConfigAvailable,
    error: (state: AppState) => state.userViewConfig.meta.error,
    loading: (state: AppState) => state.userViewConfig.meta.loading,
  };

  public static userViewConfigState = createSelector(
    this.select.userViewConfigState,
    identity
  );

  public static isInitCheckDone = createSelector(
    this.select.isInitCheckDone,
    identity
  );

  public static isValidConfigAvailable = createSelector(
    this.select.isValidConfigAvailable,
    identity
  );

  public static error = createSelector(
    this.select.error,
    identity
  );

  public static loading = createSelector(
    this.select.loading,
    identity
  );
}
